export default "__VITE_ASSET__DEvcDAqH__"